import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app.routing';

import { AppComponent } from './app.component';
import { ServicesComponent } from './services/services.component';
import { ServiceComponent } from './services/service.component';
import { ProductsComponent } from './products/products.component';
import { ProductComponent } from './products/product.component';
import { ContactComponent } from './contact/contact.component';
import { LandingComponent } from './landing/landing.component';
import { PeopleComponent } from './people/people.component';
import { ProfileComponent } from './profile/profile.component';
import { YoutubeEmbedComponent } from './utils/youtube-embed.component';
import { NavbarComponent } from './shared/navbar/navbar.component';
import { FooterComponent } from './shared/footer/footer.component';

import { HomeModule } from './home/home.module';
import { LoginComponent } from './login/login.component';

import { SafeUrlPipe } from './pipes/safe-url.pipe';

@NgModule({
  declarations: [
    AppComponent,
    ServicesComponent,
    ServiceComponent,
    ProductsComponent,
    ProductComponent,
    ContactComponent,
    LandingComponent,
    PeopleComponent,
    ProfileComponent,
    NavbarComponent,
    FooterComponent,
    LoginComponent,
    YoutubeEmbedComponent,
    SafeUrlPipe
  ],
  imports: [
    BrowserModule,
    NgbModule,
    FormsModule,
    RouterModule,
    AppRoutingModule,
    HomeModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
